import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { QaQcData } from './qa-qc-data.dto';

export class GetAllQaQcTestsResponse extends GlobalResponseObject{
    data?: QaQcData[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: QaQcData[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}
